import React from "react";
import { Modal } from "react-bootstrap";
import AssignEquipmentForm from "../Forms/AssignEquipmentForm";

const AssignEquipmentToVan = ({ show, handleClose,getVehicleEquipment, getVehicleById }) => {
  return (
    <div>
      <Modal show={show} onHide={handleClose} dialogClassName="custom-size-Equipment-modal">
        <Modal.Header style={{ backgroundColor: "#D5D5D5" }}>
          <Modal.Title className="text-black m-auto fs-3">
            Add Equipment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{}}>
          <AssignEquipmentForm getVehicleEquipment={getVehicleEquipment} getVehicleById={getVehicleById} handleClose={handleClose} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AssignEquipmentToVan;
